import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

const SendCommunicationModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useSendCommunicationModal();

  return (
    <Modal.Header>
      <h5 className="modal-title mb-0">
        <em className="icon icon-circle ni ni-send bg-primary-alt mr-2" />
        {t('NewCommunication')}
      </h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default SendCommunicationModalHeader;
